import PurchaseConfirmationModalTender from './purchaseConfirmationModalTender'

export default PurchaseConfirmationModalTender
